export interface Article {
  id: string;
  slug: string;
  title: string;
  summary: string;
  content: string;
  category: string;
  categorySlug: string;
  coverImage: string;
  publishedAt: string;
  views: number;
  comments: number;
  tags: string[];
  hot: boolean;
  featured: boolean;
}

export const articles: Article[] = [
  {
    id: '1',
    slug: 'wanghong-fanche-zuixin-bagua-2025',
    title: '某千万粉丝网红再翻车！直播带货假货被实锤，粉丝集体脱粉回踩',
    summary: '近日，拥有超过3000万粉丝的顶流网红在直播带货中被曝光售卖假冒名牌化妆品，引发全网热议。该网红曾多次标榜"只卖正品"，此次翻车让大量忠实粉丝感到愤怒和失望。',
    content: `<p>近日，拥有超过3000万粉丝的顶流网红在直播带货中被曝光售卖假冒名牌化妆品，引发全网热议。该网红曾多次标榜"只卖正品"，此次翻车让大量忠实粉丝感到愤怒和失望。</p>
<p>据知情人士透露，此次被曝光的问题产品涉及多个国际知名品牌，包括某奢侈品牌的粉底液和某知名口红品牌。消费者在收到产品后发现包装粗糙、质地异常，经专业机构检测确认为仿冒品。</p>
<p>"我一直很信任她，每次直播都会买。"一位购买了该网红推荐化妆品的消费者在社交平台上发文表示，"这次真的太失望了，退钱！"</p>
<p>截至目前，该网红尚未对此次事件作出公开回应。但其社交媒体账号评论区已被大量质疑和声讨的信息淹没，多个品牌方也表示正在调查此事。</p>
<h2>事件发酵：多人联名举报</h2>
<p>随着事件的持续发酵，越来越多的受害者站了出来。据不完全统计，已有超过500名消费者联名向相关部门举报，要求对该网红及其团队进行调查。</p>
<p>"这不仅仅是一次简单的售假问题，而是整个直播带货行业的诚信危机。"一位电商行业分析师表示，"平台方也应该承担起相应的监管责任。"</p>
<h2>律师解读：可能面临严重法律后果</h2>
<p>多位律师在接受采访时表示，如果该网红明知是假货仍然进行销售，可能涉嫌销售假冒注册商标的商品罪，将面临严重的法律后果。此外，消费者可以向销售者要求"退一赔三"的赔偿。</p>
<p>业内专家建议消费者在直播购物时应保留好交易记录和商品实物，以便在遇到问题时能够有效维权。</p>`,
    category: '网红翻车',
    categorySlug: 'wanghong-fanche',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20modern%20studio%20setting%20with%20dramatic%20lighting%2C%20a%20smartphone%20screen%20showing%20a%20live%20streaming%20interface%20with%20shopping%20cart%20and%20cosmetics%2C%20moody%20atmosphere%20with%20deep%20green%20and%20black%20tones%2C%20cinematic%20lighting%2C%20editorial%20photography%20with%20high%20contrast%20and%20soft%20shadows&width=800&height=500&seq=article-cover-1&orientation=landscape',
    publishedAt: '2026-06-30',
    views: 128500,
    comments: 3421,
    tags: ['网红翻车', '直播带货', '假货', '消费者权益'],
    hot: true,
    featured: true,
  },
  {
    id: '2',
    slug: 'zhiming-nanyixing-piitui-hunwaiqing',
    title: '知名男星被曝婚内出轨，深夜密会神秘女子，工作室紧急发声明否认',
    summary: '一则重磅爆料在娱乐圈炸开了锅：某知名一线男星被拍到深夜与一神秘女子同返公寓，举止亲密疑似婚外情。其工作室火速发布声明否认，但网友似乎并不买账。',
    content: `<p>一则重磅爆料在娱乐圈炸开了锅：某知名一线男星被拍到深夜与一神秘女子同返公寓，举止亲密疑似婚外情。其工作室火速发布声明否认，但网友似乎并不买账。</p>
<p>据娱乐记者拍到的画面显示，该男星在结束某品牌活动后，并未返回自己家中，而是驱车前往一处高档住宅小区，与一名身穿黑衣的女子会面。两人在车内交谈约20分钟后，一同进入公寓楼，直至次日凌晨该男星才独自离开。</p>
<h2>工作室紧急回应</h2>
<p>爆料发布后不到两小时，该男星的工作室便通过官方微博发布声明，称相关报道"纯属捏造"，强调该男星"与所提及女士仅为工作关系"，并表示将保留追究法律责任的权利。</p>
<p>然而，这份声明并未能平息舆论。不少网友指出，声明中的措辞模糊，既没有明确否认与女子的关系，也没有说明为何深夜单独会面。</p>
<h2>圈内人爆料更多内幕</h2>
<p>有趣的是，在工作室发布声明后，多位自称"圈内人"的网友开始爆料更多细节。有人称该男星与妻子早已貌合神离，双方各玩各的；也有人表示此次被拍的女子是某影视公司高管，与男星有多部作品合作。</p>
<p>截至目前，男星的妻子尚未对此事发表任何评论。这起事件仍在持续发酵中。</p>`,
    category: '明星八卦',
    categorySlug: 'mingxing-bagua',
    coverImage: 'https://readdy.ai/api/search-image?query=Atmospheric%20night%20cityscape%20with%20blurred%20luxury%20apartment%20building%20entrance%2C%20paparazzi%20style%20photography%20with%20moody%20warm%20and%20cool%20tones%2C%20dramatic%20shadows%2C%20editorial%20celebrity%20news%20aesthetic%20with%20dark%20green%20undertones%20and%20mysterious%20atmosphere&width=800&height=500&seq=article-cover-2&orientation=landscape',
    publishedAt: '2026-06-29',
    views: 256800,
    comments: 5823,
    tags: ['明星八卦', '婚外情', '娱乐圈', '爆料'],
    hot: true,
    featured: true,
  },
  {
    id: '3',
    slug: 'dingliu-nvxing-xianchang-heifen-huchou',
    title: '顶流女星活动现场遭黑粉现场互怼，场面一度失控，安保紧急介入',
    summary: '人气女星在某商场品牌活动上遭遇黑粉团体现身抗议，双方面对面互怼场面混乱。活动被迫中断，安保人员紧急介入维持秩序，该女星被护送离场。',
    content: `<p>人气女星在某商场品牌活动上遭遇黑粉团体现身抗议，双方面对面互怼场面混乱。活动被迫中断，安保人员紧急介入维持秩序，该女星被护送离场。</p>
<p>据悉，这起事件发生在昨日下午某知名品牌的新品发布会现场。活动原本按照流程顺利进行，但在该女星与粉丝互动环节时，一群人突然举起写有抵制标语的牌子，并高喊口号，现场顿时一片混乱。</p>
<h2>场面一度失控</h2>
<p>目击者描述，黑粉团体约有20余人，显然是有组织有预谋的行动。他们不仅举牌抗议，还与现场的粉丝发生了激烈的口角冲突，双方互不相让，场面一度失控。</p>
<p>"太可怕了，我只是来参加活动的普通顾客，没想到会遇到这种事。"一位在场顾客向记者表示，"那个女星看起来很镇定，但能感觉到她也很震惊。"</p>
<h2>品牌方发表声明</h2>
<p>事件发生后，品牌方迅速发布声明，对此次活动中的混乱局面表示歉意，并强调将加强后续活动的安保措施。同时，品牌方也表示"继续支持和信任"该代言人。</p>
<p>业内人士分析，此次事件背后可能涉及同行竞争或该女星近期某些争议言论引发的报复行为。目前，相关部门已介入调查。</p>`,
    category: '明星八卦',
    categorySlug: 'mingxing-bagua',
    coverImage: 'https://readdy.ai/api/search-image?query=Dramatic%20scene%20at%20a%20shopping%20mall%20event%20with%20crowds%20and%20security%20personnel%2C%20chaotic%20atmosphere%20with%20stage%20lights%20and%20silhouettes%2C%20editorial%20news%20photography%20style%20with%20high%20contrast%2C%20dark%20green%20and%20warm%20amber%20tones%2C%20cinematic%20documentary%20look&width=800&height=500&seq=article-cover-3&orientation=landscape',
    publishedAt: '2026-06-28',
    views: 198200,
    comments: 4102,
    tags: ['顶流女星', '黑粉', '现场冲突', '品牌活动'],
    hot: true,
    featured: false,
  },
  {
    id: '4',
    slug: 'daV-zhibo-zuimei-zhubo-bao-chouwen',
    title: '大V直播间惊现"最美主播"竟是AI换脸？技术揭秘背后黑产链条',
    summary: '某知名直播间的主播被曝实际使用的是AI换脸技术，其真实面貌与直播画面差异巨大。此事曝光后，"AI换脸直播"背后的灰色产业链浮出水面。',
    content: `<p>某知名直播间的主播被曝实际使用的是AI换脸技术，其真实面貌与直播画面差异巨大。此事曝光后，"AI换脸直播"背后的灰色产业链浮出水面。</p>
<p>事件起源于一位技术博主对该主播直播画面的深度分析。通过逐帧对比和技术检测，该博主发现主播的面部存在不自然的抖动和光影不一致的问题，最终确认这是一起使用AI换脸技术进行直播的案例。</p>
<h2>技术揭秘：如何实现"换脸直播"</h2>
<p>据技术人员介绍，实现"换脸直播"需要一套相对完整的软硬件方案。首先需要一个面容姣好的"脸模"提供面部数据，然后通过深度学习算法将主播的真实面部实时替换为脸模的面容。整个过程延迟极低，几乎无法被肉眼察觉。</p>
<p>"这项技术本身并不复杂，市面上甚至有开源的解决方案。"一位AI领域的研究者表示，"问题在于有人用它来进行商业欺诈。"</p>
<h2>灰色产业链曝光</h2>
<p>随着调查的深入，一条完整的灰色产业链浮出水面：有人专门提供"脸模"数据采集服务，有人提供换脸技术支持和设备调试，还有人负责运营和变现。整套服务的月费从几万元到几十万元不等。</p>
<p>法律专家指出，使用AI换脸技术进行直播带货且不向消费者披露的行为，涉嫌欺诈。消费者有权了解主播的真实身份，如果因此受到误导而购买了劣质商品，可以要求退货和赔偿。</p>`,
    category: '综艺热瓜',
    categorySlug: 'zongyi-regua',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20split%20screen%20showing%20a%20digital%20face%20on%20one%20side%20and%20circuit%20board%20patterns%20on%20the%20other%2C%20cyberpunk%20inspired%20design%20with%20dark%20green%20neon%20accents%2C%20futuristic%20yet%20ominous%20atmosphere%2C%20digital%20art%20style%20with%20glitch%20effects&width=800&height=500&seq=article-cover-4&orientation=landscape',
    publishedAt: '2026-06-27',
    views: 315600,
    comments: 7892,
    tags: ['AI换脸', '直播', '黑产', '技术揭秘'],
    hot: true,
    featured: true,
  },
  {
    id: '5',
    slug: 'yulequan-dafeng-shui-jinrong-neimu',
    title: '娱乐圈"大风吹"：多位艺人涉嫌金融诈骗被约谈，涉及金额超10亿',
    summary: '一场震动娱乐圈的金融风暴正在展开。据消息人士透露，多名一线艺人因涉嫌参与非法集资和金融诈骗活动被有关部门约谈，涉案金额可能超过10亿元。',
    content: `<p>一场震动娱乐圈的金融风暴正在展开。据消息人士透露，多名一线艺人因涉嫌参与非法集资和金融诈骗活动被有关部门约谈，涉案金额可能超过10亿元。</p>
<p>据了解，此次被约谈的艺人涉及范围广泛，包括影视演员、歌手、主持人等多个领域。他们被指利用自身公众人物的影响力，为某些金融平台站台背书，吸引了大量粉丝和普通投资者参与投资。</p>
<h2>非法集资的温床</h2>
<p>近年来，随着互联网金融的快速发展，一些打着"影视投资""文化基金"旗号的非法集资平台层出不穷。这些平台往往邀请知名艺人代言或出席活动，借助明星效应获取投资者的信任。</p>
<p>"很多投资者都是冲着明星去的，觉得连某某某都参与了，肯定没问题。"一位受害者家属在接受采访时泣不成声，"结果我们全家的积蓄都打了水漂。"</p>
<h2>法律后果严重</h2>
<p>法律专家表示，如果艺人明知平台存在问题仍然进行宣传推广，可能构成共同犯罪。即使是在不知情的情况下参与，也需要承担相应的民事赔偿责任。</p>
<p>目前，有关部门已经成立了专案组进行调查，预计近期将公布更多调查结果。</p>`,
    category: '黑料爆料',
    categorySlug: 'heiliao-baoliao',
    coverImage: 'https://readdy.ai/api/search-image?query=Luxurious%20office%20interior%20with%20scattered%20legal%20documents%20and%20a%20gavel%20on%20a%20dark%20wooden%20desk%2C%20dramatic%20lighting%20from%20a%20single%20window%2C%20somber%20and%20serious%20atmosphere%2C%20editorial%20photography%20with%20deep%20green%20and%20gold%20accents&width=800&height=500&seq=article-cover-5&orientation=landscape',
    publishedAt: '2026-06-26',
    views: 423100,
    comments: 12840,
    tags: ['金融诈骗', '艺人涉案', '非法集资', '娱乐圈风暴'],
    hot: true,
    featured: false,
  },
  {
    id: '6',
    slug: 'wanghong-jigou-hetong-xianjing-jiepi',
    title: 'MCN机构霸王条款曝光：网红签约后月入百万变倒贴，违约金高达500万',
    summary: '多名网红联合爆料知名MCN机构的霸王条款，称签约后不仅收入大幅缩水，还要自掏腰包支付各种费用。一旦提出解约，就要面临数百万的天价违约金。',
    content: `<p>多名网红联合爆料知名MCN机构的霸王条款，称签约后不仅收入大幅缩水，还要自掏腰包支付各种费用。一旦提出解约，就要面临数百万的天价违约金。</p>
<p>此次联合爆料的几位网红在业界都有一定知名度，其中一位在某平台拥有超过500万粉丝。他们在接受采访时表示，当初签约时被MCN机构画的大饼所吸引，但实际履行合同后才发现处处是陷阱。</p>
<h2>霸王条款逐一曝光</h2>
<p>根据爆料者提供的合同内容，这些霸王条款包括但不限于：平台收入分成比例高达8:2（机构拿8成）；网红需自行承担拍摄、化妆、服装等所有成本；账号所有权归机构所有；合同期内不得与其他任何平台合作；解约需支付年收入5倍的违约金。</p>
<p>"我签约第一年，表面上赚了200万，但扣完分成和各种费用后，到手只有不到20万。"一位爆料的网红表示，"当我提出解约时，他们直接开出了500万的违约金。"</p>
<h2>行业乱象亟待整治</h2>
<p>业内人士指出，MCN行业的野蛮生长是导致此类问题的根源。一些机构以"孵化""扶持"为名，实际上是对内容创作者的系统性剥削。</p>
<p>目前，多地市场监管部门已经开始关注MCN行业的不规范行为，相关整治行动预计将在年内展开。</p>`,
    category: '网红翻车',
    categorySlug: 'wanghong-fanche',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20office%20with%20a%20large%20contract%20on%20a%20table%2C%20dramatic%20side%20lighting%20casting%20long%20shadows%2C%20a%20pen%20and%20broken%20chain%20symbolizing%20restrictive%20agreements%2C%20editorial%20photography%20with%20dark%20green%20and%20charcoal%20tones&width=800&height=500&seq=article-cover-6&orientation=landscape',
    publishedAt: '2026-06-25',
    views: 186700,
    comments: 4530,
    tags: ['MCN机构', '霸王条款', '网红权益', '违约金'],
    hot: false,
    featured: false,
  },
  {
    id: '7',
    slug: 'dingji-nanyixing-shuihou-zhenrong-baoguang',
    title: '素颜照流出！顶流男神真实面貌曝光，整容前后对比惊人',
    summary: '一组据称是某顶流男演员的素颜照在网络上疯狂传播，照片中的他与镜头前的精致形象判若两人。网友扒出其出道前的旧照进行对比，疑似进行过多项整容手术。',
    content: `<p>一组据称是某顶流男演员的素颜照在网络上疯狂传播，照片中的他与镜头前的精致形象判若两人。网友扒出其出道前的旧照进行对比，疑似进行过多项整容手术。</p>
<p>这组照片据称是该男演员在私人聚会中被偷拍的，照片中的他皮肤粗糙、五官平平，与精修海报中的形象有着天壤之别。照片一出，立刻在社交媒体上引发热议。</p>
<h2>网友考古：从出道到现在的颜值进化史</h2>
<p>热心的网友们迅速展开了"考古"行动，扒出了该男演员从出道到现在的多张不同时期的照片进行对比。通过对比发现，其鼻子、下巴、颧骨等多个部位都发生了明显变化。</p>
<p>一位自称整形医生的网友分析称："从照片来看，他很可能做了鼻综合、下颌角磨骨、颧骨内推、双眼皮等多个项目，整体花费预计在50万以上。"</p>
<h2>粉丝反应两极分化</h2>
<p>面对偶像的真实面貌，粉丝们的反应出现了两极分化。一部分粉丝表示"塌房了"，感到被欺骗；另一部分粉丝则认为"颜值不是全部"，表示仍然会支持偶像。</p>
<p>截至目前，该男演员及其工作室均未对此事作出任何回应。其最新一条社交媒体动态的评论区已经被各种讨论淹没。</p>`,
    category: '影视八卦',
    categorySlug: 'yingshi-bagua',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20split%20composition%20showing%20a%20glamorous%20celebrity%20portrait%20on%20one%20side%20and%20a%20candid%20casual%20photo%20on%20the%20other%2C%20dramatic%20before%20and%20after%20concept%2C%20editorial%20magazine%20style%20with%20dark%20green%20and%20neutral%20tones&width=800&height=500&seq=article-cover-7&orientation=landscape',
    publishedAt: '2026-06-24',
    views: 289300,
    comments: 9250,
    tags: ['整容', '素颜照', '顶流男星', '对比图'],
    hot: false,
    featured: false,
  },
  {
    id: '8',
    slug: 'jinqian-nvmingxing-shuijun-gongguan-neimu',
    title: '惊人内幕！某女星花200万请水军"洗白"，公关公司内部聊天记录流出',
    summary: '一份据称来自某知名公关公司的内部聊天记录在网上曝光，显示某女星为消除负面新闻花费200万元雇佣水军进行大规模舆论操作。',
    content: `<p>一份据称来自某知名公关公司的内部聊天记录在网上曝光，显示某女星为消除负面新闻花费200万元雇佣水军进行大规模舆论操作。</p>
<p>从流出的聊天记录来看，该公关公司为这位女星制定了一套完整的"洗白方案"，包括但不限于：在各大平台发布正面内容、引导粉丝与黑粉对线、举报删除负面帖子、制造新话题转移注意力等。</p>
<h2>水军操作手法大揭秘</h2>
<p>聊天记录详细展示了水军的具体操作方法。首先是"占坑"，用大量正面内容淹没搜索结果；其次是"控评"，在热门帖子的评论区引导舆论方向；然后是"洗稿"，将负面新闻改写成中性或正面报道。</p>
<p>"整个操作周期大约需要2-3周，分三个阶段进行，总预算200万。"一位自称是该公关公司前员工的爆料者表示，这还只是"基础套餐"的价格。</p>
<p>此事曝光后，引起了公众对娱乐圈舆论操纵的广泛关注。多位业内人士呼吁平台加强内容审核，遏制虚假舆论的蔓延。</p>`,
    category: '音乐圈瓜',
    categorySlug: 'yinle-quangua',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20room%20with%20multiple%20computer%20monitors%20showing%20social%20media%20feeds%20and%20charts%2C%20fingers%20typing%20on%20a%20keyboard%2C%20mysterious%20and%20secretive%20atmosphere%2C%20digital%20warfare%20concept%20with%20dark%20green%20and%20cold%20blue%20screen%20glow&width=800&height=500&seq=article-cover-8&orientation=landscape',
    publishedAt: '2026-06-23',
    views: 352400,
    comments: 11230,
    tags: ['水军', '公关', '舆论操纵', '内幕曝光'],
    hot: true,
    featured: false,
  },
  {
    id: '9',
    slug: 'kuaishou-yiJie-daihuo-fensi-quanqian',
    title: '快手段子手转型带货翻车：粉丝称其"圈钱跑路"，已涉及多起投诉',
    summary: '一位以搞笑段子走红的短视频博主在转型直播带货后遭遇口碑崩塌，多名粉丝投诉其售卖的商品质量低劣、售后无门，怀疑其存在"圈钱跑路"的嫌疑。',
    content: `<p>一位以搞笑段子走红的短视频博主在转型直播带货后遭遇口碑崩塌，多名粉丝投诉其售卖的商品质量低劣、售后无门，怀疑其存在"圈钱跑路"的嫌疑。</p>
<p>该博主此前以创作搞笑短剧和模仿秀积累了数百万粉丝，被粉丝亲切地称为"开心果"。但自从今年开始涉足直播带货后，其口碑开始急剧下滑。</p>
<h2>粉丝投诉不断</h2>
<p>"我在他直播间买了一款声称'原价399现价39.9'的筋膜枪，收到后发现就是个塑料玩具，根本用不了。"一位消费者气愤地表示，"联系客服完全不理人，直播间留言质疑就直接被拉黑。"</p>
<p>类似的投诉在多个消费维权平台上不断涌现。据不完全统计，与该博主相关的投诉已达数百起，涉及的商品包括按摩仪、化妆品、保健品等多个品类。</p>
<h2>业内人士：直播带货门槛太低</h2>
<p>"直播带货的准入门槛太低是导致乱象频发的根本原因。"一位电商行业分析师指出，很多网红在没有任何供应链经验和品控能力的情况下就贸然进入带货领域，最终受害的是消费者。</p>
<p>目前，该博主的直播账号已被平台暂时封禁，相关部门也表示已经介入调查。</p>`,
    category: '网红翻车',
    categorySlug: 'wanghong-fanche',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20smartphone%20screen%20showing%20a%20live%20shopping%20stream%20with%20angry%20comment%20reactions%2C%20scattered%20cheap%20packaging%20and%20broken%20products%20around%20it%2C%20frustration%20and%20disappointment%20theme%2C%20dark%20green%20and%20red%20warning%20tones&width=800&height=500&seq=article-cover-9&orientation=landscape',
    publishedAt: '2026-06-22',
    views: 145800,
    comments: 3875,
    tags: ['短视频', '直播带货', '圈钱', '消费者投诉'],
    hot: false,
    featured: false,
  },
];

export const getArticleBySlug = (slug: string): Article | undefined => {
  return articles.find((a) => a.slug === slug);
};

export const getArticlesByCategory = (categorySlug: string): Article[] => {
  return articles.filter((a) => a.categorySlug === categorySlug);
};

export const getHotArticles = (): Article[] => {
  return articles.filter((a) => a.hot);
};

export const getFeaturedArticles = (): Article[] => {
  return articles.filter((a) => a.featured);
};

export const getLatestArticles = (limit: number = 6): Article[] => {
  return [...articles].sort((a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime()).slice(0, limit);
};

export const getRelatedArticles = (article: Article, limit: number = 3): Article[] => {
  return articles
    .filter((a) => a.id !== article.id && a.categorySlug === article.categorySlug)
    .slice(0, limit);
};
